import core from "../wrap";
export default function( sel, ctx ) {
	return core.find( sel, ctx );
}

